export default "__VITE_ASSET__ee008bc0__"